var map = {
	"./attitude-towards-theft-icon.png": 453257,
	"./conscientiousness-icon.png": 989365,
	"./integrity-honesty-icon.png": 280232,
	"./integrity-icon.png": 257911,
	"./perseverance-icon.png": 64017,
	"./risk-score-report-icon.png": 211193,
	"./work-habits-icon.png": 88347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 337668;